// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","footerText":"Footer_footerText__rlW5Y"};